import { useDisclosure } from '@mantine/hooks';
import { Button, Tooltip } from '@mantine/core';

import { EditIconSm } from '@chownow/pantry/icons';
import EditByBulkDrawer from './EditByBulkDrawer';

type EditByBulkButtonProps = {
  companyId: string;
  disabled: boolean;
  isCloned: boolean;
  menuUuid: string;
  merchantId: string;
};

export default function EditByBulkButton({
  companyId,
  disabled,
  isCloned,
  menuUuid,
  merchantId,
}: EditByBulkButtonProps) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Tooltip
        disabled={!isCloned}
        position="top"
        label="You cannot bulk edit prices in cloned menus. Use master menu to edit."
      >
        <Button
          disabled={disabled}
          size="sm"
          variant="ghost"
          leftSection={<EditIconSm />}
          onClick={open}
        >
          Edit Price
        </Button>
      </Tooltip>
      <EditByBulkDrawer
        companyId={companyId}
        merchantId={merchantId}
        menuUuid={menuUuid}
        opened={opened}
        onClose={close}
      />
    </>
  );
}
